import "./detail.less";
import { useContext, useEffect, useState } from "react";
import { Modal, Skeleton, Tooltip } from "antd";
import { deleteMonitorParameterFunc, getGlobalMonitorParameterDetail } from "@/api/lib/lib-monitor-parameter";
import { GlobalMonitorParameter } from "@/global/interface/lib-device/global-monitor-parameter";
import { getMonitorParameterTypeName } from "@/enums/monitor-parameter-type";
import MonacoEditor from '@monaco-editor/react';
import { ReactComponent as AddSvg } from '@/global/icons/side-tool/add.svg';
import AddGlobalMonitorParameterFunctionModal from "./func-add";
import { InlineMath, BlockMath } from 'react-katex';
import 'katex/dist/katex.min.css';
import { ReactComponent as DeleteSvg } from './icons/delete.svg';
import { ContextMenuFC } from "tncet-common";
import classNames from "classnames";
import TnMessage from "@/global/components/message";
import TnModal from "@/global/components/base-modal";

interface IProps {
    parameterId: number
    needRender: boolean
}

export default function LibLibMonitorParameterDetail(props: IProps) {
    const [globalParameter, setGlobalParameter] = useState<GlobalMonitorParameter>(null); // 传感器
    const [loading, setLoading] = useState<boolean>(false); // loading

    const [addVisible, setAddVisible] = useState<boolean>(false); // 添加弹窗

    const [cmOpen, setCmOpen] = useState<boolean>(false); // 是否展开右键菜单
    const [top, setTop] = useState<number>(); // 右键菜单top
    const [left, setLeft] = useState<number>(); // 右键菜单left
    const [selectedUuid, setSelectedUuid] = useState<string>(''); // 编辑的计算方法的uuid

    // 初始化
    useEffect(() => {
        if (!props?.parameterId) return;
        generateData();
    }, [props?.parameterId, props?.needRender])

    // 获取数据
    const generateData = () => {
        setLoading(true)
        getGlobalMonitorParameterDetail(+props?.parameterId).then(res => {
            let data: GlobalMonitorParameter = res.data || null;
            setGlobalParameter(data);
        }).finally(() => {
            setLoading(false);
        })
    }

    // 删除计算方法
    const onDeleteClick = () => {
        setCmOpen(false);
        if (!selectedUuid) return;
        TnModal().deleteModal({
            onOk() {
                setLoading(true);
                Modal.destroyAll();
                deleteMonitorParameterFunc(selectedUuid).then(res => {
                    if (res.status === 200) {
                        generateData();
                        TnMessage.success("删除成功");
                    }
                }).catch(err => {
                    TnMessage.error("删除失败");
                    setLoading(false);
                })
            },
            onCancel() {
                Modal.destroyAll();
            },
            closable: true,
        })

    }

    return (
        <div className="lib-parameter-detail-container">
            <Skeleton loading={loading}>
                <div className="title">
                    {globalParameter?.name || ''}
                </div>
                <div className="main">

                    <div className="item">
                        <div className="item-name">符号</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {globalParameter?.symbol || ''}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">单位</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {globalParameter?.unit || ''}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">类型</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {getMonitorParameterTypeName(globalParameter?.type) || ''}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name"><AddSvg onClick={() => setAddVisible(true)} />计算方法</div>
                        <div className="item-value-list">
                            {globalParameter?.functions?.map((item, key) => (
                                <div className={classNames({
                                    "value-block": true,
                                    "value-block-active": selectedUuid === item?.uuid,
                                })} onContextMenu={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    setCmOpen(true);
                                    setLeft(e.clientX);
                                    setTop(e.clientY);
                                    setSelectedUuid(item?.uuid);
                                }} key={key}>
                                    <div className="value-code">
                                        <MonacoEditor
                                            height="158px"
                                            defaultLanguage="python"
                                            value={item?.func || ''}
                                            theme="vs-dark"
                                            options={{
                                                minimap: { enabled: false },
                                                lineNumbers: "on",
                                                readOnly: true,
                                            }}
                                        />
                                    </div>
                                    <div className="value-button" key={key}>
                                        <Tooltip title={item?.formulaStr || ''} placement="bottom">
                                            {item?.formulaStr || ''}
                                        </Tooltip>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Skeleton>

            {addVisible && <AddGlobalMonitorParameterFunctionModal
                parameterId={props.parameterId}
                visible={addVisible}
                setVisible={setAddVisible}
                onSuccess={() => {
                    generateData();
                    setAddVisible(false);

                }}
            />}


            <ContextMenuFC
                visible={cmOpen}
                top={top}
                left={left}
                width={96}
                wrapperClassname='device-list-right-menu'
                onCancel={() => { setCmOpen(false); setSelectedUuid(null); }}
            >
                <div className="menu-item" onClick={onDeleteClick}><DeleteSvg />删除</div>
            </ContextMenuFC>
        </div>
    )
}